import React from 'react';

import { Text } from '@zg-rentals/multibrand-ui';
import SectionComment from '../SectionComment';
import { getApplicantFirstName } from '../../../../../../../utils/applicantDetailsUtil';

interface DescriptionProps {
  applicant: {
    firstName: string;
    contactInfo: {
      coapplicantFirstName: string;
    };
  };
  isLoading: boolean;
  reportText: string | JSX.Element;
  sectionComment?: string | null;
}

export default function Description({ applicant, isLoading, reportText, sectionComment = null }: DescriptionProps) {
  const applicantName = getApplicantFirstName(applicant);

  const reportTextElement = typeof reportText === 'string' ? <Text>{reportText}</Text> : reportText;
  return (
    <div className="ScreeningSectionNavLink__Description">
      {isLoading ? <Text>{'\n'}</Text> : reportTextElement}
      <SectionComment applicantName={applicantName} sectionComment={sectionComment} />
    </div>
  );
}
